export default "__VITE_ASSET__3e2bc41d__"